import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateMultiFilterByProvider } from "../../resourceExplorerSlice";
import {
  ResourceExplorerFilterItem,
  ProviderType,
} from "../../../../services/cloudchipr.api";
import { getResourceExplorerWidgetDataThunk } from "../widgets/getResourceExplorerWidgetDataThunk";
import { RootState } from "../../../store";
import { resourceExplorerFilterByKeyAndProviderSelector } from "../../selectors/filters/resourceExplorerFilterByKeyAndProviderSelector";

interface ResourceTypeFilterChangeThunkArg {
  filter: ResourceExplorerFilterItem;
  provider: ProviderType;
}

export const resourceTypeFilterChangeThunk = createAsyncThunk(
  "resourceExplorer/resourceTypeFilterChange",
  (
    { filter, provider }: ResourceTypeFilterChangeThunkArg,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;
    const currentSavedFilter = resourceExplorerFilterByKeyAndProviderSelector(
      state,
      "service",
      provider,
    );
    if (!currentSavedFilter && !filter.value?.length) {
      return;
    }
    dispatch(
      updateMultiFilterByProvider({
        filter,
        provider,
      }),
    );
    dispatch(getResourceExplorerWidgetDataThunk());
  },
);
